import { Component, ViewChild, ViewEncapsulation, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CriteriaFormComponent } from '../criteria/criteria.form.component';
import { VisionService } from '../services/vision.service';
import { SpinnerService } from '../services/spinner';
import { SurveyTypes } from '../models/surveytypes';
import { CriteriaService } from '../services/criteria.service';
import { CriteriaOptionDetails } from '../models/dto/criteria-options-details';
import { Observable } from 'rxjs/Observable';
import { SurveyDetails } from '../models/dto/survey';
import { CriteriaDetails } from '../models/dto/criteria';
import { VisionModel } from '../models/vision.model';
import { CriteriaModel } from '../models/criteria.model';

@Component({
  selector: 'app-criteria.add',
  templateUrl: './criteria.add.component.html',
  styleUrls: ['./criteria.add.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CriteriaAddComponent implements OnInit, OnDestroy {

  closeResult: string;
  user: any;
  email: string;
  user_data: any;
  user_id: string;
  surveyData: any;
  surveyTypeId: number;
  newSurveyTitle: string;
  isCreateNewSurvey = false;
  title = '';
  form1Title = '';
  userSurveys: Array<SurveyDetails>;
  importance: number;
  isConditions: boolean;
  errorMsg = '';
  criteriaData: CriteriaDetails;
  conditionItems: Array<CriteriaOptionDetails> = [];
  showSpinner = false;
  disableButton = true;
  dataInserted = false;
  current_survey: any;
  survey_data: SurveyDetails;
  current_criterias: Array<CriteriaDetails>;
  criterias_titles = '';
  tempForms: Array<any> = [];
  displayArray: Array<any> = [];
  allValid = 0;

  // forms
  criteriaTitle: FormControl;
  criteriaCondition: FormControl;
  criteriaForm: FormGroup;

  constructor(private visionService: VisionService, private criteriaService: CriteriaService,
    private renderer: Renderer2,
    private surveyTypes: SurveyTypes, private modalService: NgbModal, private route: ActivatedRoute, private router: Router,
    private visionModel: VisionModel, private criteriaModel: CriteriaModel, private spinnerService: SpinnerService) {

    this.addAnotherForm();
    this.renderer.addClass(document.body, 'container_bg');
    this.user = JSON.parse(localStorage.getItem('user_data'));
    this.email = this.user.email;
    this.user_id = this.user.id;
    this.newSurveyTitle = localStorage.getItem('vision_title');
    this.surveyTypeId = this.surveyTypes.getTitleId(this.newSurveyTitle); // selected vision
    const currentSurvey = localStorage.getItem('current_survey');
    if (currentSurvey && currentSurvey !== 'null') {
      this.current_survey = JSON.parse(currentSurvey);
      visionService.getVisionData(this.current_survey.id).subscribe(result => {
        this.survey_data = result.Survey;
        this.current_criterias = this.survey_data.criterias;
        this.getCriteriasTitles();
      });
    }
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['importance']) {
        this.importance = +params['importance'];
      }
      if (params['visiontype']) {
        this.surveyTypeId = params['visiontype'];
        this.isCreateNewSurvey = true;
      }
    });

    // Add new vision if parameter visiontype sent  then add new vision
    if (this.isCreateNewSurvey) {
      this.newSurveyTitle = this.surveyTypes.getTitle(this.surveyTypeId);
      // change current vision
      this.changeCurrentSurvey(this.surveyTypeId);
    }

    this.criteriaTitle = new FormControl('criteriaTitle', Validators.required);
    this.criteriaCondition = new FormControl('');
    this.criteriaForm = new FormGroup({
      criteriaTitle: this.criteriaTitle,
      criteriaCondition: this.criteriaCondition
    });

  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'container_bg');
  }
  addTitle(post) {
    this.title = post;
  }
  addTitle2(post) {
    this.title = post;
    document.getElementById('closeModalButton').click();
  }

  addImportance(val) {
    if (this.criteriaTitle.valid) {
      this.importance = val;
    } else {
    }
  }
  toggleConditions(val) {
    if (this.title !== '') {
      this.isConditions = true;
    }
  }
  addCondition(formTitle, radioValue, formNumber) {
    if (this.conditionItems.length > 0) {
      this.disableButton = false;
    }

    if (this.formIsValid(formTitle, radioValue)) {
      this.tempForms[formNumber].valid = true;
      const criteriaOption: CriteriaOptionDetails = { title: formTitle, importance: radioValue, addIndex: formNumber };
      this.deleteRepeatedTitleFromArray(formNumber);
      this.conditionItems.push(criteriaOption);
    } else {
      this.tempForms[formNumber].valid = false;
    }
  }

  reassignConditionSelected() {
  }
  formIsValid(textValue: string, radioValue: any) {
    if ((textValue !== '') && (radioValue && radioValue !== '')) {
      return true;
    } else {
      return false;
    }
  }
  openAddConditionsModal(content) {
    this.modalService.open(content, { windowClass: 'modal-conditions' });
  }

  titleChange(refValue) {
    if (!refValue || refValue === '') {
      this.disableButton = true;
    } else {
      this.disableButton = false;
    }
  }
  addAnotherForm() {
    // add another conditions form
    if (this.conditionItems.length > 0) {
      this.disableButton = false;
    }
    const index = this.tempForms.length;
    this.tempForms.push({ form: 'form' + index, status: 'display', valid: false });
    this.displayArray.push({ index: index, display: 1 });
  }

  onFormChange(formOutput: Array<any>) {
    let formTitle: any;
    let radioValue: any;
    let formNumber: any;
    formOutput.forEach(element => {
      if (formOutput[0].formTitle) { formTitle = formOutput[0].formTitle; }
      if (formOutput[0].radioValue) { radioValue = formOutput[0].radioValue; }
      if (formOutput[0].formNumber) { formNumber = formOutput[0].formNumber; }
    });
    if (!formNumber || formNumber === undefined) {
      formNumber = 0;
    }
    if (formTitle && radioValue) {
      this.addCondition(formTitle, radioValue, formNumber);
    }
  }
  closePopupModal() {
    document.getElementById('closeModalButton').click();
  }
  open(content) {
    this.modalService.open(content).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  openAddExamplesModal(content) {
    this.modalService.open(content, { windowClass: 'crtAdd-examples' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  openEmptyModal(content) {
    this.modalService.open(content, { windowClass: 'crtAdd-emptyMod' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  registerCriteria() {
    if (this.conditionItems.length < 1) {
      this.disableButton = true;
      return true;
    }
    this.spinnerService.show();
    this.disableButton = true;
    const currentSurvey = localStorage.getItem('current_survey');
    if (!currentSurvey || currentSurvey === 'null') {
      // Add new vision
      this.newSurveyTitle = this.surveyTypes.getTitle(this.surveyTypeId);
      this.createNewVision().subscribe(result => {
        this.addNewCriteria();
      });
    } else {
      this.addNewCriteria();
    }
  }

  addNewCriteria() {
    this.criteriaData = { title: this.title, importance: this.importance, options: this.conditionItems };
    const surveyData = localStorage.getItem('current_survey');
    if (surveyData) { this.surveyData = JSON.parse(surveyData); }
    // check if exist first
    let isExist = true;
    this.criteriaModel.criteriaIsExist(this.title).subscribe(result => {
      if (result === true) {
        isExist = true;
      } else {
        isExist = false;
        this.addNewCriteriaAfterCheck();
      }
    });
    localStorage.setItem('criteria1', JSON.stringify(this.criteriaData));
  }
  addNewCriteriaAfterCheck() {
    this.spinnerService.show();
    this.disableButton = true;
    this.criteriaService
      .addNewCriteria(this.title, +this.importance, this.surveyData.id)
      .subscribe(data => {

        // add new options
        let allMutations = `mutation {`;
        let index = 0;
        this.conditionItems.forEach(option => {
          index++;
          allMutations += this.criteriaService.buildAddOption(index, data.createCriteria.id, option.title, +option.importance);
        });
        allMutations += ' }';
        this.criteriaService.mutateEditCriteria(allMutations).subscribe(resp => {
          this.spinnerService.hide();
          this.disableButton = false;
          this.router.navigateByUrl('vision/editcriterias'); // redirect after adding options
        });
      },
      error => {
        return false;
      });
  }

  cancelCriteria() {
    this.router.navigateByUrl('home/user'); // redirect after adding options
  }

  checkIfDataLoaded(): Promise<any> {
    if (this.dataInserted === true) {
      return new Promise((resolve, reject) => {
        resolve(true);
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve(false);
      });
    }
  }

  getCriteriasTitles() {
    let i = 0;
    if (this.current_criterias) {
      this.current_criterias.forEach(criteria => {
        this.criterias_titles += criteria.title;
        if (i < this.current_criterias.length - 1) { this.criterias_titles += ','; }
        i++;
      });
    }
  }

  createNewVision() {
    return this.visionService.getUserVisions(this.email).map(result => {
      this.user_data = result.User;
      if (this.user_data.surveys) {
        const isExist = this.user_data.surveys.filter(x => x.title === this.newSurveyTitle)[0];
        if (isExist) {
          this.visionService.getVisionData(isExist.id).subscribe(data => {
            this.survey_data = data.Survey;
            localStorage.setItem('current_survey', JSON.stringify(data.Survey));
            return false;
          });
        } else {
          this.addNewVision().subscribe(data2 => {
            return result; // true or false created
          });
        }
      }
    });
  }

  addNewVision() {
    this.showSpinner = true;
    this.disableButton = true;

    return this.visionService.addNewVision(this.newSurveyTitle, this.email, this.user_id, this.visionService.getTypeJobsId())
      .map(({ data }: any) => {
        localStorage.setItem('current_survey', JSON.stringify(data.createSurvey));
        localStorage.setItem('vision_title', this.newSurveyTitle);
        this.visionModel.setSurveysInStorage(data.createSurvey);
        this.showSpinner = false;
        this.disableButton = false;
        return true;
      },
      error => {
        return false;
      }
      );
  }

  changeCurrentSurvey(visionType) {
    // check if vision available to add
    this.visionModel.visionIsExist(visionType).subscribe(result => {
      // change current vision localstorage values
      if (result === true) {
        this.visionModel.setSurveyInStorageFromType(visionType).subscribe(data => {
        });
        this.surveyData = JSON.parse(localStorage.getItem('current_survey'));
        localStorage.setItem('vision_title', this.newSurveyTitle);
        this.surveyTypeId = this.surveyTypes.getTitleId(this.newSurveyTitle); // selected vision
      } else {
        localStorage.setItem('current_survey', null);
        localStorage.setItem('vision_title', this.newSurveyTitle);
        this.surveyTypeId = this.surveyTypes.getTitleId(this.newSurveyTitle); // selected vision
      }
    });
  }

  clearTitle(formTitleNumber) {
    if (formTitleNumber === 1) {
      this.title = '';
    }
  }

  emptyTitleFromArray(formNumber: number) {
    const selectedItem = this.conditionItems.filter(x => x.addIndex === formNumber)[0];
    if (selectedItem) {
      const index: number = this.conditionItems.indexOf(selectedItem);
      if (index !== -1) {
        this.conditionItems[index].title = '';
      }
    }
  }

  deleteRepeatedTitleFromArray(formNumber: number) {
    const selectedItem = this.conditionItems.filter(x => x.addIndex === formNumber)[0];
    if (selectedItem) {
      const index: number = this.conditionItems.indexOf(selectedItem);
      if (index !== -1) {
        this.conditionItems.splice(index, 1);
      }
    }
  }

  onElementDeleted(elementIndex: any) {
    if (elementIndex !== -1) {
      this.tempForms[elementIndex].status = 'deleted';
      this.displayArray[elementIndex].display = 0;
      this.emptyTitleFromArray(elementIndex);
      this.reCheckAllFormsValidity();
    }
  }

  onFormError(refValue) {
    if (refValue === 1) {
      this.disableButton = true;
    } else if (refValue === 0) {
      this.disableButton = false;
    }
  }

  reCheckAllFormsValidity() {
    let isValid = true;
    this.tempForms.forEach(form => {
      if (form.status === 'display' && form.valid === false) {
        isValid = false;
        return isValid;
      }
    });
    if (isValid) {
      this.allValid = 1;
    }
    return isValid; // default return isValid true
  }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/criteria/criteria.add.component.ts